import {useDropzone} from 'react-dropzone';

interface Props {
  onDrop: (files: File[]) => void;
}

export function Dropzone({onDrop}: Props) {
  const {getRootProps, getInputProps, isDragActive, fileRejections} = useDropzone({
    onDrop,
    multiple: true,
  });

  const baseClass =
    'border-2 border-dashed rounded-2xl p-10 sm:p-16 text-center transition-colors select-none';
  const stateClass = isDragActive
    ? 'border-sky-500 bg-sky-50 cursor-copy'
    : 'border-slate-300 hover:border-slate-400 cursor-pointer';

  return (
    <div>
      <div {...getRootProps({className: `${baseClass} ${stateClass}`})}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p className="text-sky-700 font-medium">Отпусти файлы здесь</p>
        ) : (
          <p className="text-base text-slate-700">
            Перетащите сюда файлы или НАЖМИТЕ чтобы выбрать
          </p>
        )}
      </div>
      {fileRejections.length > 0 && (
        <ul className="mt-3 text-sm text-red-600">
          {fileRejections.map(({file, errors}) => (
            <li key={file.name}>
              {file.name}: {errors.map((e) => e.message).join(', ')}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
